module.exports = __webpack_public_path__ + "img/first-login.48043050.png";